import { render, staticRenderFns } from "./Element.vue?vue&type=template&id=e6f48ea6&lang=pug"
import script from "./Element.vue?vue&type=script&lang=js"
export * from "./Element.vue?vue&type=script&lang=js"
import style0 from "./Element.vue?vue&type=style&index=0&id=e6f48ea6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports